import {useEffect, useState} from "react";
import {getFromLocalStorage, setToLocalStorage} from "../utils/localStorageUtils";
import {
    DARK_THEME,
    DARK_THEME_CLASS_NAME,
    LIGHT_THEME,
    LOCAL_STORAGE_THEME
} from "../utils/constants";

const STORAGE_PERIOD_IN_HOURS = 365 * 24;

const getSavedTheme = () => {
    return getFromLocalStorage(LOCAL_STORAGE_THEME)?.value || LIGHT_THEME;
};

const applyTheme = (theme) => {
    const bodyClassList = document.body.classList;

    if (theme === LIGHT_THEME) {
        bodyClassList.remove(DARK_THEME_CLASS_NAME);
    } else {
        bodyClassList.add(DARK_THEME_CLASS_NAME);
    }
};

export default function useThemeToggle() {
    const [themeType, setThemeType] = useState(getSavedTheme);

    useEffect(() => {
        applyTheme(themeType);
        setToLocalStorage(LOCAL_STORAGE_THEME, {value: themeType}, STORAGE_PERIOD_IN_HOURS);
    }, [themeType]);

    const toggleTheme = () => {
        setThemeType(currentTheme => currentTheme === LIGHT_THEME ? DARK_THEME : LIGHT_THEME);
    };

    return {
        themeType,
        toggleTheme,
    };
}
